const KEY_PREFIX = 'superAdminMode.'

export interface SuperAdminContext {
  enabled: boolean
  companyId?: string
  companyName?: string
}

export const getSuperAdminContext = (): SuperAdminContext => ({
  enabled: sessionStorage.getItem(`${KEY_PREFIX}enabled`) === 'true',
  companyId: sessionStorage.getItem(`${KEY_PREFIX}companyId`) || undefined,
  companyName: sessionStorage.getItem(`${KEY_PREFIX}companyName`) || undefined,
})

export const setSuperAdminContext = (ctx: Partial<SuperAdminContext>) => {
  if ('enabled' in ctx) sessionStorage.setItem(`${KEY_PREFIX}enabled`, String(ctx.enabled))
  if ('companyId' in ctx && ctx.companyId !== undefined)
    sessionStorage.setItem(`${KEY_PREFIX}companyId`, ctx.companyId)
  if ('companyName' in ctx && ctx.companyName !== undefined)
    sessionStorage.setItem(`${KEY_PREFIX}companyName`, ctx.companyName)
}

export const clearSuperAdminContext = () => {
  sessionStorage.removeItem(`${KEY_PREFIX}enabled`)
  sessionStorage.removeItem(`${KEY_PREFIX}companyId`)
  sessionStorage.removeItem(`${KEY_PREFIX}companyName`)
}
